import React, {useEffect} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Container} from "../containers/Container";
import {selectLoginStatus} from "../../redux/auth/authSlice";
import {HeroHeading2} from "../text";
import {AccountProfileSectionView} from "./AccountProfileSectionView";
import {RealmServiceError} from "../../errors/realmServiceError";
import {WarningColorIcon} from "../icons";
import {StoreEmptyStateView} from "../storeFeed/StoreEmptyStateView";
import {useRouter} from "next/router";
import {useModalRouting} from "../../utils/useModalRouting";
import {AccountSubscriptionSectionView} from "./AccountSubscriptionSectionView";
import {resetCheckoutSession, selectCheckoutSessionUrl} from "../../redux/upgrade/subscriptionSlice";
import {EventLogger} from "../../utils/eventLogger";
import {AnalyticsEvent} from "../../utils/eventProperties";

export const AccountView: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const { createRoute } = useModalRouting()
  const loginStatus = useAppSelector(selectLoginStatus)
  const checkoutSessionUrl = useAppSelector(selectCheckoutSessionUrl)

  useEffect(() => {
    EventLogger.logEvent(new AnalyticsEvent({ eventName: 'Screen Visited', screenName: 'Profile' }))
  }, [])

  useEffect(() => {
    if (checkoutSessionUrl) {
      window.location.href = checkoutSessionUrl
      dispatch(resetCheckoutSession())
    }
  }, [checkoutSessionUrl, dispatch])

  return <Container className="mb-32">
    <StoreEmptyStateView
      className={`${loginStatus === 'not_logged_in' ? '' : 'hidden'}`}
      onClick={() => {
        router.push(
          createRoute({ name: 'login', query: { config: 'sign_in' } }),
          undefined,
          { shallow: true }
        );
      }}
      buttonTitle={t('auth:auth_title_sign_in')}
      error={new RealmServiceError('NOT_LOGGED_IN')}
      icon={<WarningColorIcon />}
      isLoading={false}
    />

    <div className={`w-full space-y-6 ${loginStatus === 'logged_in' || loginStatus === 'logged_in_anon' ? '' : 'hidden'}`}>
      <HeroHeading2>Your Account</HeroHeading2>

      <AccountProfileSectionView />

      <AccountSubscriptionSectionView />
    </div>
  </Container>
}